(function () {
    'use strict';

    angular.module('swif.achats')

        .config(
            function($routeProvider) {
                $routeProvider.when('/achats-stocks/consumables/statistics_view', {
                    templateUrl: 'partials/achats/consumables_statistics_view.html',
                    controller: 'AchatsConsumablesStatisticsController',
                    controllerAs: '$ctrl',
                    reloadOnSearch: false,
                    resolve: {
                        d3: function (swifRouteService) {
                            return swifRouteService.check({resources: ['d3']});
                        }
                    }
                });
            }
        )

        .controller('AchatsConsumablesStatisticsController',
            function ($scope, swif, swifStatisticsService, swifDownloadService) {
                console.log('init AchatsConsumablesStatisticsController');
                swif.settings.page.title = 'Statistics';
                var $ctrl = this;

                var download = swifDownloadService;

                $ctrl.years = swifStatisticsService.getYears();
                $ctrl.tableData = [[]];
                $ctrl.theadMonthLabels = [];
                $ctrl.group_by_choices = [];

                $ctrl.barChartData = [];
                $ctrl.pieChartData = [];
                $ctrl.totalEqualZero = true;

                $ctrl.barChartData = [];
                $ctrl.pieChartData = [];
                $ctrl.totalEqualZero = 0;

                $ctrl.searchFilter = {
                    periodType: 'manual',
                    start_period: swifStatisticsService.getDefaultStartPeriod(),
                    end_period: swifStatisticsService.getDefaultEndPeriod(),
                    service_ids:[],
                    warehouse_ids:[],
                    type_ids: [],
                    consumable_ids: [],
                    purchase_order_ids: [],
                    department_contained: []
                };

                $ctrl.barChartOptions = {
                    chart: {
                        type: 'historicalBarChart',
                        height: 450,
                        margin : {
                            top: 30,
                            right: 75,
                            bottom: 50,
                            left: 75
                        },
                        x: function(d){return d[0];},
                        y: function(d){return d[1];},
                        showValues: true,
                        valueFormat: function(d){
                            return d3.format(',.1f')(d);
                        },
                        duration: 100,
                        color: ['#2ca02c', 'darkred'],
                        xAxis: {
                            tickFormat: function(d) {
                                return d3.time.format('%m/%Y')(new Date(d))
                            },
                            showMaxMin: true
                        },
                        yAxis: {
                            axisLabel: 'Somme des sorties de stock',
                            axisLabelDistance: -10,
                            tickFormat: function(d){
                                return d3.format(',f')(d);
                            }
                        },
                        tooltip: {
                            keyFormatter: function(d) {
                                return d3.time.format('%m/%Y')(new Date(d));
                            }
                        }
                    }
                };

                $ctrl.pieChartOptions = {
                    chart: {
                        type: 'pieChart',
                        height: 500,
                        x: function(d){return d.key;},
                        y: function(d){return d.y;},
                        showLabels: true,
                        duration: 500,
                        labelThreshold: 0.01,
                        labelSunbeamLayout: true,
                        legend: {
                            margin: {
                                top: 5,
                                right: 30,
                                bottom: 0,
                                left: 0
                            }
                        }
                    }
                };

                $ctrl.getXSum = getXSum;

                $scope.$watchGroup(['$ctrl.searchFilter.start_period', '$ctrl.searchFilter.end_period'],
                    function (newV, oldV) {
                        if(!_.contains(newV, undefined) && !_.contains(newV, false)) {
                            // update month column label
                            $ctrl.theadMonthLabels = [];
                            var months = moment().range($ctrl.searchFilter.start_period, $ctrl.searchFilter.end_period);
                            months.by('months', function (monthItem) {
                                $ctrl.theadMonthLabels.push(moment(monthItem).format('MM/YYYY'));
                            });
                            getMovesForTable();
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.periodType',
                    function (newV, oldV) {
                        if(newV && !angular.equals(newV, oldV)) {
                            if(newV !== 'manual') {
                                $ctrl.searchFilter.start_period = newV + '-01-01';
                                $ctrl.searchFilter.end_period = newV + '-12-31';
                            }
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.service_ids',
                    function (newV, oldV) {
                        if (!_.isEmpty(newV)) {
                            getMovesForTable();
                            getDepartmentLevel(newV);
                        } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                            //user have delete the last warehouse
                            getMovesForTable();
                        }
                        if (_.isEmpty(newV) && _.isEmpty(oldV)){
                            // we need to init the group by
                            getDepartmentLevel();
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.department_contained',
                    function (newV, oldV) {
                        if (!_.isEmpty(newV)) {
                            getMovesForTable();
                        } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                            //user have delete the last warehouse
                            getMovesForTable();
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.warehouse_ids',
                    function (newV, oldV) {
                        if (!_.isEmpty(newV)) {
                            getMovesForTable();
                        } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                            //user have delete the last warehouse
                            getMovesForTable();
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.type_ids',
                    function (newV, oldV) {
                        if (!_.isEmpty(newV)) {
                            getMovesForTable();
                        } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                            //user have delete the last type
                            getMovesForTable();
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.consumable_ids',
                    function (newV, oldV) {
                        if (!_.isEmpty(newV)) {
                            getMovesForTable();
                        } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                            //user have delete the last consumable
                            getMovesForTable();
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.purchase_order_ids',
                    function (newV, oldV) {
                        if (!_.isEmpty(newV)) {
                            getMovesForTable();
                        } else if (!_.isEmpty(oldV) && _.isUndefined(newV)){
                            //user have delete the last consumable
                            getMovesForTable();
                        }
                    });

                $scope.$watch('$ctrl.searchFilter.group_by',
                    function (newV, oldV) {
                        if (!_.isEmpty(newV)) {
                            getMovesForTable();
                        } else if (!_.isEmpty(oldV) && _.isEmpty(newV)){
                            //user have unselect the group by
                            getMovesForTable();
                        }
                    });

                function getDepartmentLevel(ids){
                    swif.data.callKw(
                        'department',
                        'get_service_level',
                        [ids],
                        {context: swif.user.getAuthenticatedUser().context}
                    ).then(function (data) {
                        $ctrl.group_by_choices = [];
                        for(let i=1; i<=data ; i++){
                            $ctrl.group_by_choices.push({'name':'Service demandeur - Niveau '+i, 'id':i});
                        }
                        return true;
                    });
                }

                function getMovesForTable() {
                    swif.data.callKw(
                        'stock_move',
                        'get_move_statistics',
                        null,
                        {context: swif.user.getAuthenticatedUser().context, filters:sanitizeParams()}
                    ).then(function (data) {
                        updatePieChart(data);
                        addTotalRow(data);
                        $ctrl.tableData = data;
                        updateBarChart();
                        return true;
                    });
                };

                function updatePieChart(data){
                    $ctrl.pieChartData = [];
                    data.forEach(function (resultLine) {
                        $ctrl.pieChartData.push({'key' : resultLine.key[0], 'y':getXSum(resultLine.values).toFixed()});
                    });
                }

                function updateBarChart(){
                    $ctrl.barChartData = [{
                        "key" : "Quantity" ,
                        "bar": true,
                        "values" : []
                    }];
                    // we use the total line previously compute to make the graph
                    $ctrl.tableData[$ctrl.tableData.length-1].values.forEach(function (columnTotal){
                        $ctrl.barChartData[0].values.push([moment(columnTotal[0], 'YYYY-MM').toDate(),
                            parseInt(columnTotal[1])]);
                    });
                }

                // @param data: (Array) values of the current row to sum
                function getXSum (data) {
                    var ret = 0.0;
                    _.forEach(data, function (item) {
                        ret += item[1];
                    });
                    return ret;
                }

                // sanitize filters data and create the array of params
                function sanitizeParams(){
                    var filters = {};
                    if ($ctrl.searchFilter.start_period){
                        filters.date_start = $ctrl.searchFilter.start_period;
                    }
                    if ($ctrl.searchFilter.end_period){
                        filters.date_end = $ctrl.searchFilter.end_period;
                    }
                    if ($ctrl.searchFilter.service_ids){
                        if ($ctrl.searchFilter.service_ids.length>0) {
                            filters.service_ids = $ctrl.searchFilter.service_ids;
                        }
                    }
                    if ($ctrl.searchFilter.warehouse_ids){
                        if ($ctrl.searchFilter.warehouse_ids.length>0) {
                            filters.warehouse_ids = $ctrl.searchFilter.warehouse_ids;
                        }
                    }
                    if ($ctrl.searchFilter.type_ids){
                        if ($ctrl.searchFilter.type_ids.length>0) {
                            filters.type_ids = $ctrl.searchFilter.type_ids;
                        }
                    }
                    if ($ctrl.searchFilter.consumable_ids){
                        if ($ctrl.searchFilter.consumable_ids.length>0) {
                            filters.consumable_ids = $ctrl.searchFilter.consumable_ids;
                        }
                    }
                    if ($ctrl.searchFilter.purchase_order_ids){
                        if ($ctrl.searchFilter.purchase_order_ids.length>0) {
                            filters.purchase_order_ids = $ctrl.searchFilter.purchase_order_ids;
                        }
                    }
                    if ($ctrl.searchFilter.group_by){
                        filters.group_by = $ctrl.searchFilter.group_by[0];
                    }
                    if ($ctrl.searchFilter.department_contained){
                        if ($ctrl.searchFilter.department_contained.length>0) {
                            filters.department_contained = $ctrl.searchFilter.department_contained;
                        }
                    }
                    return filters;
                }

                function addTotalRow(data) {
                    const totalLabel = "Total";
                    data.push({"key": [totalLabel], "values": []});
                    let total = 0;
                    // for each columns
                    for (let i = 0; i < data[0].values.length; i++) {
                        let sum = 0;
                        _.forEach(data, function (item) {
                            if (item.key[0] != totalLabel) {
                                //add each line value
                                sum += item.values[i][1] || 0.0;
                            }
                        });
                        total += sum;
                        data[data.length - 1].values[i] = [data[0].values[i][0], sum];
                    }
                    $ctrl.totalEqualZero = (total === 0);
                }

                $ctrl.exportCsv = function(){

                    download.params = swif.data._computeSaveAsPOST(
                        'statistics_stock_move',
                        'csv_data',
                        false,
                        'csv_data_filename',
                        {
                            filters: sanitizeParams()
                        }
                    );
                };
            }
        );
})();
